module.exports = __webpack_public_path__ + "img/mobile_logo.32da6ee0.png";